import { makeAutoObservable } from 'mobx'
import { isLink } from 'shared/lib'
import { type INormalizedApiError } from 'shared/api'
import { type IResponseRcsCompliance } from 'entities/Rcs'

export class BrandTermsStore {
  private _privacyPolicyUrl = ''
  private _privacyPolicyError = ''
  private _termsAndConditionsUrl = ''
  private _termsAndConditionsError = ''

  constructor() {
    makeAutoObservable(this)
  }

  get privacyPolicyUrl() {
    return this._privacyPolicyUrl
  }

  get privacyPolicyError() {
    return this._privacyPolicyError
  }

  get termsAndConditionsUrl() {
    return this._termsAndConditionsUrl
  }

  get termsAndConditionsError() {
    return this._termsAndConditionsError
  }

  get isValid() {
    return isLink(this._privacyPolicyUrl) && isLink(this._termsAndConditionsUrl)
  }

  setPrivacyPolicyUrl = (url: string) => {
    this._privacyPolicyUrl = url
    if (this._privacyPolicyError) this._privacyPolicyError = ''
  }

  setTermsAndConditionsUrl = (url: string) => {
    this._termsAndConditionsUrl = url
    if (this._termsAndConditionsError) this._termsAndConditionsError = ''
  }

  private _getUrlError = (url: string) => {
    if (!url) return 'Enter a URL'
    return isLink(url) ? '' : 'Enter a valid URL'
  }

  validatePrivacyPolicyUrl = () => {
    this._privacyPolicyError = this._getUrlError(this._privacyPolicyUrl)
  }

  validateTermsAndConditionsUrl = () => {
    this._termsAndConditionsError = this._getUrlError(this._termsAndConditionsUrl)
  }

  validate = () => {
    this._privacyPolicyError = this._getUrlError(this._privacyPolicyUrl)
    this._termsAndConditionsError = this._getUrlError(this._termsAndConditionsUrl)

    return Boolean(this._privacyPolicyError || this._termsAndConditionsError)
  }

  init = (data: IResponseRcsCompliance) => {
    this._privacyPolicyUrl = data.privacy_policy_url || ''
    this._termsAndConditionsUrl = data.terms_url || ''
  }

  initErrors = (errors: INormalizedApiError) => {
    this._privacyPolicyError = errors.getError('privacy_policy_url')
    this._termsAndConditionsError = errors.getError('terms_url')
  }

  reset = () => {
    this._privacyPolicyUrl = ''
    this._privacyPolicyError = ''
    this._termsAndConditionsUrl = ''
    this._termsAndConditionsError = ''
  }
}
